import { useTheme } from '@emotion/react';
import React from 'react';
import StyledH4 from '../../components/structure/StyledH4';
import { ProjectsContainer } from './SustainableProjectsReel.styles';
import { t } from '../../translations';

export const SustainableProjectsReel = () => {
  const url = t('projects')('projectsUrl');
  const theme = useTheme();

  return (
    <ProjectsContainer>
      <StyledH4 style={{ padding: theme.fontSize.giga }}>
        {t('projects')('projectsDesc')}
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
        >
          {t('projects')('projectsUrlName')}
        </a>
      </StyledH4>
    </ProjectsContainer>
  );
};
